import moment from 'moment';
import Paginate from 'vuejs-paginate';
import { EmojiPicker } from 'vue-emoji-picker';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import SectorService from "../services/Sector";

if($('#dashboard-messages-component').length){
    var app = new Vue({
        el: '#dashboard-messages-component',
        data: {
            threads:[],
            messages:[],
            users:[],
            newMessage: '',
            userId: userId,
            receiverId: receiverId,
            threadSearch: '',
            userSearch: '',
            activeThread:null,
            activeMessages:{},
            filter:null,
            loadingThread:true,
            loadingMessages:false,
            messageFile:null,
            file: null,
            errors: [],
            loadingFile: false,
            sendingMessage: false,
            loadingThreads: false,
            index: 0,
            history: {},
            search: '',
            messagesPagination : {},
            total_messages: 0,
            scroll: true,
            current_page: 1,
            current_thread_page: 1,
            emptyThread: false,
            connections: [],
            showConnectionsSelect: false,
            unreadMessagesCount: 0,
            allow: allow,
            api_url: api_url
        },
        methods: {
            setEmptyThread() {
                this.getConnectedUsers();
                this.activeThread = false;
                this.emptyThread = true;
                this.showConnectionsSelect = true;
            },
            getConnectedUsers() {
                this.loadingMessages = true;
                axios.get('/messages/get-connected-users')
                    .then((response) => {
                        this.connections = response.data;
                        this.loadingMessages = false;
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                        this.loadingMessages = false;
                    })
            },
            setSelected(value) {
                this.showConnectionsSelect = false;
                this.loadingMessages = true;
                let thread = {
                    'user_one': this.userId,
                    'user_two': value
                }
                this.postThread(thread)
                    .then((response)=>{
                        this.activeThread = response.data.data;
                        this.getMessages(this.activeThread);
                        this.emptyThread = false;
                        this.connections = [];
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
            },
            append(emoji) {
                this.newMessage += emoji
            },
            postThread: function(thread){
                this.scroll = true;
                return axios.post(this.api_url + '/api/v1/threads', thread);
            },
            getThreads: function (page = 1, status = false) {
                this.scroll = true;
                if (status) {
                    this.loadingThreads = true;
                    axios.get(this.api_url + '/api/v1/threads?search=' + this.threadSearch + '&filter=' + this.filter + '&page=' + page, {
                        'headers': {
                            'Accept': 'application/json'
                        }
                    })
                        .then((response) => {
                            if (page === 1) {
                                this.threads = [];
                                this.index = 0;
                                this.current_thread_page = 1;
                            }
                            this.history = response.data;
                            for (const element of response.data.data) {
                                this.threads[this.index] = element;
                                this.index++;
                            }
                            this.current_thread_page = page;
                            this.loadingThreads = false;

                            let url = location.href.split('messages/');
                            if (url.length == 2) {
                                this.getThread(url[1])
                            }
                        })
                        .catch((error) => {
                            this.errorHandler(error);
                            this.loadingThreads = false;
                        })
                }
            },
            getThread(id) {
                this.loadingThreads = true;
                axios.get('/get-thread/' + id, {
                    'headers': {
                        'Accept': 'application/json'
                    }
                })
                    .then((response) => {
                        this.selectThread(response.data.data)
                        this.loadingThreads = false;
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                        this.loadingThreads = false;
                    })
            },
            selectThread(thread){
                this.activeMessages = {};
                this.activeThread = thread;
                this.newMessage = '';
                this.messageFile = '';
                this.file = null;
                this.scroll = true;
                this.emptyThread = false;
                this.getMessages(this.activeThread);
            },
            getMessages: function(thread, page = 1){
                this.loadingMessages = true;
                return axios.get('/messages/thread/' + thread.id + '?page=' + page, {
                    'headers': {
                        'Accept': 'application/json'
                    }
                })
                .then((response) =>  {
                    if (page === 1) {
                        this.activeMessages = {};
                        this.total_messages = 0;
                        this.current_page = 1;
                    }
                    this.messagesPagination = response.data.messagesData;
                    for (const i in response.data.messages) {
                        if (i in this.activeMessages) {
                            let index = this.activeMessages[i].length;
                            for (let j = 0; j < response.data.messages[i].length; j++) {
                                this.activeMessages[i][index] = response.data.messages[i][j];
                                index++;
                            }
                        } else {
                            this.activeMessages[i] = response.data.messages[i];
                        }
                        this.total_messages += response.data.messages[i].length;
                    }
                    if (thread.unread_messages > 0) {
                        this.updateThreadMessagesStatus(thread.id, 'read', true, true);
                    }
                    this.current_page = page;
                    this.loadingMessages = false;
                })
                .catch((error) => {
                    this.errorHandler(error);
                })
            },
            newThread: function(){
                this.activeThread = null;
                this.activeMessages = {};
            },
            postMessage: function(id = null){
                this.scroll = true;
                this.sendingMessage = true;
                var fileName = '';
                if(this.messageFile){
                    fileName = this.file.name;
                }
                var message = {
                    'to': this.activeThread.receiver.id, 
                    'message': this.newMessage,
                    'file-location':this.messageFile,
                    'file-name':fileName,
                    'id': id,
                    'allow': this.allow
                }
                return axios.post('/messages', message)  
                .then((response) =>  {
                    this.getMessages(this.activeThread);
                    this.getThreads();
                    this.newMessage = '';
                    this.messageFile = '';
                    this.file = null;
                    this.sendingMessage = false;
                })
                .catch((error) => {
                    this.errorHandler(error);
                    this.sendingMessage = false;
                })         
            },
            debounceInput: _.debounce(function (e) {
                this.threadSearch = e.target.value;
                if(this.threadSearch){
                    if(this.threadSearch.length >= 3){
                        this.activeThread = null;
                        this.activeMessages = {};
                        this.loadingThreads = true;
                        this.getThreads(1, true);
                    }
                }else{
                    this.activeThread = null;
                    this.activeMessages = {};
                    this.loadingThreads = true;
                    this.getThreads(1, true);
                }
            }, 500),
            isActive: function(thread){
                if(this.activeThread){
                    if(this.activeThread.id == thread.id){
                        return true;
                    }
                }
                return false;
            },
            searchUsers: _.debounce(function (e) {
                if(this.userSearch.length >= 3){
                    axios.get('/messageable-users?search='+this.userSearch, {
                        'headers': {
                            'Accept': 'application/json'
                        }
                    })
                    .then((response) =>  {
                        this.users = response.data;
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
                }else{
                    this.users = [];
                }
            }, 500),
            selectUser: function(id) {
                var thread = {
                    'user_one': this.userId,
                    'user_two': id
                }
                this.postThread(thread)
                .then((response)=>{
                    this.activeThread = response.data.data;
                    this.users = null;
                    this.getThreads();
                    this.getMessages(this.activeThread);
                })
                .catch((error) => {
                    this.errorHandler(error);
                })
            },
            updateThreadMessagesStatus: function(threadId, filter, load, state = false){
                if (state) {
                    if (load) {
                        this.loadingThreads = true;
                    }
                    var status = 'read';
                    if (filter) {
                        status = filter;
                    }
                    axios.put('/thread/' + threadId + '/status', {
                        'status': status
                    })
                        .then((response) => {
                            this.getUnreadMessagesCount();
                            this.getThreads(1, true)
                        })
                        .catch(function (error) {
                            console.log(error)
                            this.loadingThreads = false;
                        })
                }
            },
            updateArchived: function(thread){
                this.loadingThreads = true;

                var status;

                if(thread.archived.archived){
                    status = false;
                }else{
                    status = true;
                }

                axios.put('/thread/archived', {
                    'threadId': thread.id,
                    'user': thread.archived.user,
                    'status': status
                })
                .then((response) =>  {
                    this.getThreads(1, true)
                })
                .catch((error) => {
                    this.errorHandler(error);
                    this.loadingThreads = false;
                })
            },
            uploadFile: function(file, bearer){

                axios.defaults.headers.common["Authorization"] = bearer;
                this.loadingMessages = true;

                const formData = new FormData();
                formData.append('file-name', file.name);
                formData.append('file-type', file.type);
                formData.append('file', file);

                axios.post('/api/v1/message/generate-upload-url', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then((response) => {
                    this.messageFile = response.data.success;
                    this.loadingMessages = false;
                }).catch(error => {
                    this.errorHandler(error);
                    this.loadingMessages = false;
                });
            },
            handleFilesUpload(event){
                let allow = false;
                this.errors = [];
                var bearer = axios.defaults.headers.common["Authorization"];
                this.file = event.target.files[0];

                if (event.target.files && event.target.files[0]) {
                    const reader = new FileReader();

                    reader.onload = () => {
                        const arrayBuffer = reader.result;
                        const bytes = new Uint8Array(arrayBuffer);
                        const headerBytes = bytes.subarray(0, 4);

                        if (this.file.type == 'text/plain') {
                            const arr = new Uint8Array(arrayBuffer).subarray(0, 10);
                            allow = true;
                            for (let i = 0; i < arr.length; i++) {
                                if (arr[i] < 32 || arr[i] > 126) {
                                    allow = false;
                                    break;
                                }
                            }
                        } else if (this.file.type == 'application/msword' || this.file.type == 'application/vnd.ms-excel'
                            || this.file.type == 'application/vnd.ms-powerpoint') {
                            const expectedHeaderBytes = new Uint8Array([0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1]);
                            const isMsWordFile = bytes.length >= expectedHeaderBytes.length &&
                                expectedHeaderBytes.every((value, index) => bytes[index] === value);
                            if (isMsWordFile) {
                                allow = true;
                            }
                        } else if (this.file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                            || this.file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            || this.file.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
                            const isZipFile = bytes[0] === 0x50 && bytes[1] === 0x4B && bytes[2] === 0x03 && bytes[3] === 0x04;
                            if (isZipFile) {
                                allow = true;
                            }
                        } else if (this.file.type == 'application/pdf') {
                            if (String.fromCharCode.apply(null, headerBytes) === '%PDF') {
                                allow = true;
                            }
                        } else if (this.file.type == 'image/jpeg' || this.file.type == 'image/gif' || this.file.type == 'image/png') {
                            const header = headerBytes.reduce((acc, byte) => acc + byte.toString(16), '');
                            switch (header) {
                                case '89504e47':
                                    allow = true;
                                    break;
                                case '47494638':
                                    allow = true;
                                    break;
                                case 'ffd8ffe0':
                                case 'ffd8ffe1':
                                case 'ffd8ffe2':
                                    allow = true;
                                    break;
                            }
                        }

                        if (allow) {
                            if (this.file.size < 25000000) {
                                if (this.file) {
                                    this.uploadFile(this.file, bearer);
                                }
                            } else {
                                this.file = null;
                                this.$toasted.error('The file you are trying to upload is too large, it must be under 25Mb');
                            }
                        } else {
                            this.file = null;
                            this.$toasted.error('The uploaded file contains invalid extension.<br>Allowed file types:.txt, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .jpg, .jpeg, .gif, and .png');
                        }
                    };

                    if (this.file.type == 'application/msword' || this.file.type == 'application/vnd.ms-excel'
                        || this.file.type == 'application/vnd.ms-powerpoint') {
                        const blob = this.file.slice(0, 8);
                        reader.readAsArrayBuffer(blob);
                    } else if (this.file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                        || this.file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        || this.file.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
                        const blob = this.file.slice(0, 4);
                        reader.readAsArrayBuffer(blob);
                    } else {
                        reader.readAsArrayBuffer(this.file);
                    }
                }
            },
            removeFile: function(){
                this.messageFile = null;
                this.file = null;
            },
            getTime: function(time){
                var dateFormat = 'HH:mm';
                var testDateUtc = moment.utc(time);
                var localDate = testDateUtc.local();
                return localDate.format(dateFormat);
            },
            getTime12(time) {
                let localDate = moment.utc(time).local();
                return localDate.format('LT');
            },
            getDate(date) {
                let f_date = moment(date, "DD-MM-YYYY");
                return moment(f_date).format('ll').toUpperCase();
            },
            unreadTotal: function(){
                var i = 0;
                $.each(this.threads, function(key, value) {
                    if(value.unread_messages){
                        i++;
                    }
                });
                return i;
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
            },
            getHistory(page){
                this.getThreads(page, true)
            },
            getMessagesHistory(page){
                this.scroll = false;
                this.getMessages(this.activeThread, page)
            },
            getUnreadMessagesCount() {
                this.unreadMessagesCount = 0;
                axios.get(this.api_url + '/api/v1/get-unread-messages-count')
                    .then((response) => {
                        if (response.data) {
                            this.unreadMessagesCount = response.data;
                        }
                    }).catch((error) => {
                    console.log(error);
                });
            },
            loadThreads() {
                if (this.threads.length === 0) {
                    this.getThreads(1, true)
                }
            }
        },
        directives: {
            focus: {
                inserted(el) {
                    el.focus()
                },
            },
        },
        mounted () {
            this.loadingThreads = true;
            if (this.receiverId) {
                var thread = {
                    'user_one': this.userId,
                    'user_two': this.receiverId
                }
                this.postThread(thread)
                    .then((response) => {
                        this.activeThread = response.data.data;
                        this.users = null;
                        this.getThreads(1, true);
                        this.getMessages(this.activeThread);
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    });
            } else {
                this.getUnreadMessagesCount();
                if (location.href.includes("/dashboard/messages")) {
                    this.loadThreads()
                }
            }
        },
        updated: function () {
            if (this.scroll) {
                let objDiv = document.getElementById("messages-section");
                if (objDiv) {
                    objDiv.scrollTop = objDiv.scrollHeight;
                }
            }
        },
        watch: {
            filter: function () {
                this.getThreads(1, true);
            }
        },
        components: {
            'paginate': Paginate,
            EmojiPicker,
            'v-select': vSelect
        },
        computed: {
            disableButton() {
                return !!(!this.emptyThread && ((this.newMessage && !this.loadingMessages) || this.messageFile));
            }
        }
    });
}